import React from 'react';

import Login from './Login';

const LoginPage = () => <Login />;

export default LoginPage;
